import React from "react";
import { FaHeart } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-gray-950 text-gray-400 text-center py-4 mt-6">
      <p className="text-sm">
        Developed with <FaHeart className="inline text-red-500 mx-1" /> by
        <a href="https://github.com/jigneshk5" target="_blank" className="font-semibold text-white ml-1">Jignesh Kumar</a>
      </p>
      <p className="text-xs mt-1">
        Copyright © 2025 Geekpoint Technologies Pvt. Ltd.
      </p>
    </footer>
  );
};

export default Footer;
